import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthenticatedGuard } from './shared/guards';
import { UnauthenticatedGuard } from './shared/guards/unauthenticated.guard';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        /* define app module routes here, e.g., to lazily load a module
       (do not place feature module routes here, use an own -routing.module.ts in the feature instead)
     */
        {
          path: 'auth',
          loadChildren: () => import('./login/login.module').then((mod) => mod.LoginModule),
        },
        {
          path: 'account-recovery',
          canActivate: [UnauthenticatedGuard],
          loadChildren: () =>
            import('./account-recovery/account-recovery.module').then(
              (mod) => mod.AccountRecoveryModule
            ),
        },
        {
          path: 'invitations',
          loadChildren: () =>
            import('./accept-invitation/accept-invitation.module').then(
              (mod) => mod.AcceptInvitationModule
            ),
        },
        {
          path: 'signup',
          loadChildren: () =>
            import('./account-creation/account-creation.module').then(
              (mod) => mod.AccountCreationModule
            ),
        },
        {
          path: 'verification',
          loadChildren: () =>
            import('./account-verification/account-verification.module').then(
              (mod) => mod.AccountVerificationModule
            ),
        },
        {
          path: '',
          canActivate: [AuthenticatedGuard],
          loadChildren: () => import('./home/home.module').then((mod) => mod.HomeModule),
        },
      ],
      {}
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
